export default function formatPrice(amount: number): string {
  return amount.toLocaleString("pl-PL") + " zł brutto";
}
